/**
 * `returnTo` validation shared by Login, AuthContext and the OAuth consent
 * page (issue #257, Issue 3 of .claude/docs/tasks/mcp-oauth/context.md).
 *
 * Mirrors the backend's `OAUTH_RETURN_TO_PATTERN` in `backend/routes/auth.js`
 * byte for byte. Keeping a single client-side copy (rather than duplicating
 * the regex literal in three components) means Login's Google link, the
 * dev/demo login success redirect, and the consent page's logged-out
 * redirect can never drift out of sync with each other — only with the
 * backend, which re-validates independently anyway (defense in depth: this
 * is a redirect target, so nothing here is trusted without a server-side
 * check too).
 */

export const OAUTH_RETURN_TO_PATTERN = /^\/oauth\/consent\?request=[A-Za-z0-9_-]{1,128}$/;

/**
 * @param {string|null|undefined} value
 * @returns {boolean}
 */
export function isValidOauthReturnTo(value) {
  return typeof value === 'string' && OAUTH_RETURN_TO_PATTERN.test(value);
}
